import { isValidIP } from '@/utils/valid-ip.js';

// Get IPv4 address from IPREGISTRY with fallback endpoints
const getIPFromIPREGISTRY = async (originalSite) => {
    // Use backend API to avoid CORS issues
    const endpoints = [
        { url: "/api/ipregistry?ip=auto", field: "ip", name: "IPREGISTRY" },
        { url: "https://api.ipify.org?format=json", field: "ip", name: "IPify (fallback)" },
        { url: "https://ipinfo.io/json", field: "ip", name: "IPinfo.io (fallback)" },
    ];
    
    for (const endpoint of endpoints) {
        try {
            const response = await fetch(endpoint.url);
            
            if (!response.ok) {
                continue;
            }

            const data = await response.json();
            
            const ip = data[endpoint.field] || data.ip; // Handle different response formats
            
            if (isValidIP(ip)) {
                return {
                    ip: ip,
                    source: `${endpoint.name} IPv4`
                };
            }
        } catch (error) {
            // Continue to next endpoint on error
        }
    }
    
    return {
        ip: null,
        source: "All IPv4 endpoints failed"
    };
};

export { getIPFromIPREGISTRY };
